<template>
    <div class="container">
        <div id="captchaContainer"></div>
        <input hidden id="captchaResponse" ref="captchaResponse"/>
    </div>
</template>
<script>
export default {
    data(){
        return {}
    },
    created(){
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=renderCaptcha&render=explicit');
        recaptchaScript.setAttribute('async', '');
        recaptchaScript.setAttribute('defer', '');

        window.renderCaptcha = () => {
            window.grecaptcha.render('captchaContainer', {
                'sitekey' : '6Lfw6F0oAAAAAB4r6OjOJ2mv_aQPaTYZrVjoz6ET',
                'callback' : (data) => {
                    document.getElementById('captchaResponse').value = data;
                },
                'theme' : 'dark'
            });
        }

        document.head.appendChild(recaptchaScript);
    },
    methods:{
        isCompleted(){
            const response = document.getElementById('captchaResponse').value;
            if(response) return true;
            return false;
        }
    }
}
</script>
<style lang="scss" scoped>

    .container{
        display: flex;
        justify-content: center;
    }

</style>